import { create } from "zustand"
import { persist } from "zustand/middleware"

interface AdminArealStore {
    selectedArealId: string | null
    setSelectedArealId: (id: string) => void
    clearSelectedArealId: () => void
}

export const useAdminArealStore = create<AdminArealStore>()(
    persist(
        (set) => ({
            selectedArealId: null,
            setSelectedArealId: (id) => set({ selectedArealId: id }),
            clearSelectedArealId: () => set({ selectedArealId: null }),
        }),
        { name: "admin-areal" },
    ),
)
